import React, { useState } from "react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";

export default function Question({faq}) {
    const [questionVisibility, setQuestionVisibility] = useState(false);
	return (
        <div key={faq.id}>
            <dt className="font-semibold text-gray-900" onClick={() => {
                    setQuestionVisibility(!questionVisibility);
                }}>
                    {faq.question}
                    <ChevronUpIcon
                        className="inline-block ml-1 w-4"
                        style={{ transform: questionVisibility ? "rotate(0deg)" : "rotate(180deg)" }}
                    />
            </dt>
            {questionVisibility && (
                <dd className="mt-3 text-gray-800">{faq.answer}</dd>
            )}
        </div>
    )
}